import React from 'react';
import Typography from '@material-ui/core/Typography';

const Headline = (props) => {
  const variant = props.variant ? props.variant : "h2";
  return <Typography variant={variant} gutterBottom style={{display: 'block'}}>{props.children}</Typography>
}

export { Headline }
